import { z } from 'zod';
export const LLM_PROVIDERS = ['openai', 'openrouter', 'azure'];
export const LLM_FALLBACK_PROVIDERS = ['openai'];
export const llmGatewaySettingsSchema = z.object({
    enabled: z.boolean().optional(),
    provider: z.enum(LLM_PROVIDERS).optional(),
    fallback_enabled: z.boolean().optional(),
    fallback_provider: z.enum(LLM_FALLBACK_PROVIDERS).optional(),
});
export const llmSettingsPatchSchema = llmGatewaySettingsSchema;
export const llmUsageQuerySchema = z.object({
    project_id: z.string().uuid(),
    days: z.coerce.number().min(1).max(365).default(30),
});
export const llmOrgUsageQuerySchema = z.object({
    days: z.coerce.number().min(1).max(365).default(30),
});
//# sourceMappingURL=llm.js.map